import common from './common'
import openData from './openData'
import qdt from './qdt'

export default {
  common,
  openData,
  qdt,
}
